import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  FormControl,
  FormLabel,
  Text,
  HStack,
  VStack,
  Box,
} from "@chakra-ui/react";
import { OnChangeValue, Select } from "chakra-react-select";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PageContent } from "../../components/PageContent/PageContent";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { useAdminApiRequest } from "../../hooks/useApiRequest";
import { chakraStyles } from "../../components/fields/SelectField/ChakraReactSelectField";
import { TwilioBillingUsagesTable } from "../../components/Report/TwilioBillingUsagesTable";
import { orderBy } from "lodash";

export const TwilioBillingUsagesReport = () => {
  type Option = { label: string; value: number | undefined };
  const currentYear = new Date().getFullYear();

  const [selectedYear, setSelectedYear] = useState<number>(currentYear);

  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth() + 1
  );

  const monthOptions = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const range = (start: number, stop: number, step: number) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    );

  const yearOptions = range(currentYear, 2000, -1).map((year) => ({
    label: year.toString(),
    value: year,
  }));

  const {
    data: billingUsages,
    isLoading: isLoading,
    refresh,
  } = useAdminApiRequest(
    (client) =>
      client.getTwilioBillingUsages("DataAPI", selectedMonth, selectedYear),
    []
  );

  const onSelectYear = (e: OnChangeValue<Option, false>) => {
    setSelectedYear(e?.value!);
  };

  const onSelectMonth = (e: OnChangeValue<Option, false>) => {
    setSelectedMonth(e?.value!);
  };

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Twilio Billing</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <VStack w="100%" alignItems="flex-start">
          <Breadcrumb variant="pageHeading">
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/admin/reports">
                Reports
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/admin/reports/twilio-billing">
                Twilio Billing
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          <Text as="h2" fontSize="lg" fontWeight="bold" color="cherryUi.600">
            Reporting Filter:
          </Text>
          <HStack mt={4} w="100%" spacing={6}>
            <FormControl flex={1}>
              <FormLabel>Year</FormLabel>
              <Select
                defaultValue={yearOptions.find(
                  (type) => type.value == selectedYear
                )}
                chakraStyles={chakraStyles}
                options={yearOptions}
                placeholder="Select year.."
                onChange={onSelectYear}
              />
            </FormControl>

            <FormControl flex={1}>
              <FormLabel>Month</FormLabel>
              <Select
                defaultValue={monthOptions.find(
                  (type) => type.value == selectedMonth
                )}
                chakraStyles={chakraStyles}
                options={monthOptions}
                placeholder="Select month.."
                onChange={onSelectMonth}
              />
            </FormControl>

            <Box flex={4} flexShrink={1} alignSelf="flex-end">
              <Button colorScheme="cherryButton" onClick={refresh}>
                Run
              </Button>
            </Box>
          </HStack>
          <TwilioBillingUsagesTable
            data={orderBy(
              billingUsages?.map((item) => {
                item.UsageCount = item.UsageCount ?? 0;
                item.UsagePrice = item.UsagePrice ?? 0;
                return item;
              }),
              ["UsageCount", "SmsSenderId"],
              ["desc", "asc"]
            )}
            isLoading={isLoading}
          />
        </VStack>
      </PageContent>
    </>
  );
};
